import React from "react";
import { RentLinkedAccountsListScreenContainer } from "src/containers";

export const RentLinkedAccountsListScreen = () => {
  return <RentLinkedAccountsListScreenContainer />;
};
